(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[538],{

/***/ 4184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 8350:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/experience",
      function () {
        return __webpack_require__(4764);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ experience; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/atoms/Container/index.ts + 1 modules
var Container = __webpack_require__(4232);
// EXTERNAL MODULE: ./layout/Layout/index.ts + 17 modules
var Layout = __webpack_require__(2092);
// EXTERNAL MODULE: ./data/job.json
var job = __webpack_require__(2443);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
// EXTERNAL MODULE: ./components/atoms/Box/index.ts + 1 modules
var Box = __webpack_require__(9399);
;// CONCATENATED MODULE: ./components/molecules/Job/Job.tsx



var Job = function(param) {
    var company = param.company, jobTitle = param.jobTitle, fromDate = param.fromDate, toDate = param.toDate, technologies = param.technologies, shortDescription = param.shortDescription, index1 = param.index;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col md:flex-row flex-wrap justify-between text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-xs font-semibold  mb-4 ".concat((index1 == 0 || index1 == 3) && "underline underline-offset-4 decoration-wavy"),
                        children: "Click on the box for full responsibilities*"
                    }),
                    (index1 == 0 || index1 == 3) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-xs font-semibold mb-4 text-red-500 underline underline-offset-4 decoration-wavy"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-4 border md:mb-0 md:border-0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-4 items-start md:items-center",
                children: [
                    company.logo && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                        src: company.logo,
                        alt: company.name,
                        width: 64,
                        height: 64,
                        className: "rounded-md"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full mb-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col-reverse md:flex-row justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "font-bold",
                                        children: jobTitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "text-sm md:text-base",
                                        children: [
                                            fromDate,
                                            " - ",
                                            toDate
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "text-sm font-normal",
                                children: company.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: company.url,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "underlined relative",
                                    children: company.name
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: company.name
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "hidden md:block text-sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Technologies: "
                                    }),
                                    technologies.join(", ")
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "md:hidden text-sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "Technologies: "
                    }),
                    technologies.join(", ")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "ml-5 mt-2 list-disc",
                children: shortDescription.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "leading-relaxed",
                        children: item
                    }, index);
                })
            })
        ]
    });
};


;// CONCATENATED MODULE: ./components/molecules/Job/index.ts


;// CONCATENATED MODULE: ./components/organisms/WorkExperience/WorkExperience.tsx




var WorkExperience = function(param1) {
    var jobs = param1.jobs;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: jobs.map(function(param, index) {
            var company = param.company, jobTitle = param.jobTitle, fromDate = param.fromDate, toDate = param.toDate, technologies = param.technologies, shortDescription = param.shortDescription;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: "/experience/".concat(index),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("flex transition-all transform-gpu md:hover:-translate-y-4 cursor-pointer ", {
                        "justify-end": index % 2 !== 0
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Job, {
                        company: company,
                        jobTitle: jobTitle,
                        fromDate: fromDate,
                        toDate: toDate,
                        technologies: technologies,
                        shortDescription: shortDescription,
                        index: index
                    })
                }, "".concat(company, " ").concat(jobTitle))
            }, index);
        })
    });
};


;// CONCATENATED MODULE: ./components/organisms/WorkExperience/index.ts


;// CONCATENATED MODULE: ./pages/experience/index.tsx





var ExperiencePage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* Layout */.A, {
        title: "Job Experience about Krutik Parikh",
        description: "Work Experience of software developer.",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "headline text-3xl md:text-5xl lg:text-6xl mt-8",
                    children: "Hi, I'm Krutik Parikh!"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "headline text-xl md:text-2xl lg:text-3xl",
                    children: "Nice to meet you."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "headline mt-12 mb-4 text-4xl",
                    children: "Experience"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WorkExperience, {
                    jobs: job
                })
            ]
        })
    });
};
/* harmony default export */ var experience = (ExperiencePage);


/***/ }),

/***/ 1163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(880)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [61,336,761,774,888,179], function() { return __webpack_exec__(8350); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);